import React, {useEffect, useState} from "react";
import axios from "axios";
import LMBLoggingDashboard from "../Berende/LMB-LoggingDashboard";

const NieuweApi = () => {
  const [formData, setFormData] = useState({
    naam: '',
    code: '',
    machines: [],
  });
  const [Machines, setMachines] = useState([]);

  useEffect(() => {
    const fetchMachines = async () => {
      const response = await axios.get(`/api/machine/get/all`);

      console.log(response);

      await setMachines(response.data);
    };

    fetchMachines()
  }, [])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleChangeList = (e) => {
    console.log(formData);
    console.log(e.target.value, e.target.checked)
    if (e.target.checked) {
      formData.machines.push(e.target.value);
    } else {
      formData.machines.forEach((machine, i) => {
        if (e.target.value === machine) {
          formData.machines.splice(i, 1);
        }
      })
    }
    setFormData(formData)
  };

  const Nieuw = async (e) => {
    await axios.get(`/api/key/create`, {
      params: {
        naam: formData.naam,
        machines: formData.machines,
      }
    });
    window.location.href="/api";
  };

  return (
    <div className={"pl-14 pr-14 flex flex-col items-center gap-10 p-2"}>
      <div className="flex w-full h-full justify-center gap-10">
        <dialog id={"loading"} open className={"top-52 z-50 text-center text-9xl p-10 rounded-lg shadow-xl bg-white select-none hidden flex-col gap-10"}>
          Laden...
          <h1 className={"text-2xl"}>dit kan even duren</h1>
        </dialog>
        <div className="flex w-2/6 flex-col items-center gap-5 bg-white rounded-md shadow-lg p-8">
          <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Maak Een Nieuwe Api Key</h1>
          <form onSubmit={Nieuw} id={"form"} className="flex flex-col items-center gap-4 rounded-md justify-center w-full">
            <div className="w-full flex flex-col gap-1">
              <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Naam</h1>
              <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="Bijvoorbeeld jjmderidder api key" name="naam" value={formData.naam} onChange={handleChange} required/>
            </div>
            <ul>
              {Machines?.map(machine => (
                <li key={machine.alias}><input name={"machines"} type={"checkbox"} value={machine.serialNumber} onChange={handleChangeList}/> {machine.organization} {machine.alias} {machine.model}</li>
              ))}
            </ul>
            <input
              className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"
              type="submit" value={"Maak Api"}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default NieuweApi;